var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.cof.js
// module id = 17
// module chunks = 0